var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI18N(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.839 14.958l-2.447-2.418.029-.03a16.879 16.879 0 003.574-6.29h2.823V4.291h-6.744V2.365H8.147v1.927H1.402V6.22h10.762a15.193 15.193 0 01-3.054 5.155 15.076 15.076 0 01-2.226-3.228H4.958a16.923 16.923 0 002.87 4.393l-4.903 4.837 1.368 1.368 4.817-4.817 2.997 2.996.732-1.965m5.424-4.885h-1.927l-4.335 11.562h1.927l1.079-2.89h4.576l1.089 2.89h1.927l-4.336-11.562m-2.524 6.744l1.56-4.172 1.561 4.172z",
    fill: "#7986cb"
  })));
}
export default SvgI18N;